<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-mais-vida
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :url="link"
          :cidades="enableCidades"
          :vendedores="enableVendedores"
          :redes="enableRedes"
          :produtos="enableProdutos"
          :areas="enableAreas"
          :btn1="enableBtn"
          :btn2="disableBtn"
          :enable-datas="enableDatas"
          :produto-multiplo="enableProdutoMultiplo"
          :segmentos="enableSegmento"
        />
        <v-container>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-container><br>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Controle de Mix Médio praticado geral
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('237')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-mix-medio-geral />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="cidadeSelect1"
              :items="cidadeLocal"
              item-value="id"
              item-text="cidade"
              label="Cidades"
              return-object
            />
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="areaSelect1"
              :items="filterAreas1.length > 0 ? filterAreas1 : areaLocal"
              item-value="id"
              item-text="area"
              label="Areas"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ areaSelect1.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma área
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroAreas"
                      v-model="filtroAreas"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Áreas"
                      @change="filterAreasToggle"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleAreas"
                >
                  <v-list-item-action>
                    <v-icon :color="areaSelect1.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconAreas }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todas
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="redeSelect1"
              :items="filterRedes1.length > 0 ? filterRedes1 : redeLocal"
              item-value="id"
              item-text="rede"
              label="Redes"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ redeSelect1.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma rede
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroRedes"
                      v-model="filtroRedes"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Redes"
                      @change="filterRedesToggle"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleRedes"
                >
                  <v-list-item-action>
                    <v-icon :color="redeSelect1.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconRedes }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="vendedorSelect1"
              :items="filterVendedor1.length > 0 ? filterVendedor1 : vendedorLocal"
              item-value="id"
              item-text="vendedor"
              label="Vendedores"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ vendedorSelect1.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                Selecione um vendedor
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroVendedores"
                      v-model="filtroVendedores"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Vendedores"
                      @change="filterVendedoresToggle"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleVendedores"
                >
                  <v-list-item-action>
                    <v-icon :color="vendedorSelect1.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconVendedores }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            v-if="segmentoLocal.length > 0"
            id="selectEmpresa"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="segmentoSelect1"
              :items="segmentoLocal"
              item-value="idExibicao"
              item-text="segmento"
              label="Segmento Cliente"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ segmentoSelect1.length - 2 }} outros)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col
            id="btnRefazerCidade"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-btn
              class="pa-2 ma-2"
              small
              :color="corPrimaria"
              dark
              @click="updateCidade1()"
            >
              <v-icon>
                mdi-reload-alert
              </v-icon>
              Refazer
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Controle de Mix Médio praticado por cidade
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('238')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-grafico-mix-medio-cidade1 />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="cidadeSelect2"
              :items="cidadeLocal"
              item-value="id"
              item-text="cidade"
              label="Cidades"
              return-object
            />
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="areaSelect2"
              :items="filterAreas2.length > 0 ? filterAreas2 : areaLocal"
              item-value="id"
              item-text="area"
              label="Areas"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ areaSelect2.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma área
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroAreas"
                      v-model="filtroAreas2"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Áreas"
                      @change="filterAreasToggle2"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleAreas2"
                >
                  <v-list-item-action>
                    <v-icon :color="areaSelect2.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconAreas2 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todas
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="redeSelect2"
              :items="filterRedes2.length > 0 ? filterRedes2 : redeLocal"
              item-value="id"
              item-text="rede"
              label="Redes"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ redeSelect2.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma rede
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroRedes"
                      v-model="filtroRedes2"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Redes"
                      @change="filterRedesToggle2"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleRedes2"
                >
                  <v-list-item-action>
                    <v-icon :color="redeSelect2.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconRedes2 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="vendedorSelect2"
              :items="filterVendedor2.length > 0 ? filterVendedor2 : vendedorLocal"
              item-value="id"
              item-text="vendedor"
              label="Vendedores"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ vendedorSelect2.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                Selecione um vendedor
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroVendedores"
                      v-model="filtroVendedores2"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Vendedores"
                      @change="filterVendedoresToggle2"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleVendedores2"
                >
                  <v-list-item-action>
                    <v-icon :color="vendedorSelect2.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconVendedores2 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            v-if="segmentoLocal.length > 0"
            id="selectEmpresa"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="segmentoSelect2"
              :items="segmentoLocal"
              item-value="idExibicao"
              item-text="segmento"
              label="Segmento Cliente"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ segmentoSelect2.length - 2 }} outros)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col
            id="btnRefazerCidade"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-btn
              class="pa-2 ma-2"
              small
              :color="corPrimaria"
              dark
              @click="updateCidade2()"
            >
              <v-icon>
                mdi-reload-alert
              </v-icon>
              Refazer
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Controle de Mix Médio praticado por cidade
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('238')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-grafico-mix-medio-cidade2 />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="cidadeSelect3"
              :items="cidadeLocal"
              item-value="id"
              item-text="cidade"
              label="Cidades"
              return-object
            />
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="areaSelect3"
              :items="filterAreas3.length > 0 ? filterAreas3 : areaLocal"
              item-value="id"
              item-text="area"
              label="Areas"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.area }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ areaSelect3.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma área
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroAreas"
                      v-model="filtroAreas3"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Áreas"
                      @change="filterAreasToggle3"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleAreas3"
                >
                  <v-list-item-action>
                    <v-icon :color="areaSelect3.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconAreas3 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todas
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="redeSelect3"
              :items="filterRedes3.length > 0 ? filterRedes3 : redeLocal"
              item-value="id"
              item-text="rede"
              label="Redes"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.rede }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ redeSelect3.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                selecione uma rede
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroRedes"
                      v-model="filtroRedes3"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Redes"
                      @change="filterRedesToggle3"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleRedes3"
                >
                  <v-list-item-action>
                    <v-icon :color="redeSelect3.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconRedes3 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            id="cidadeSelectBtn"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="vendedorSelect3"
              :items="filterVendedor3.length > 0 ? filterVendedor3 : vendedorLocal"
              item-value="id"
              item-text="vendedor"
              label="Vendedores"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.vendedor }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ vendedorSelect3.length - 2 }} outros)
                </span>
              </template>
              <template v-slot>
                Selecione um vendedor
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <input
                      id="filtroVendedores"
                      v-model="filtroVendedores3"
                      prepend-inner-icon="mdi-account-search"
                      placeholder="Filtrar Vendedores"
                      @change="filterVendedoresToggle3"
                    >
                  </v-list-item-action>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  /><br>
                </v-list-item>
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleVendedores3"
                >
                  <v-list-item-action>
                    <v-icon :color="vendedorSelect3.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconVendedores3 }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title id="idSelecTotos">
                    Selecionar todos
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                />
              </template>
            </v-select>
          </v-col>
          <v-col
            v-if="segmentoLocal.length > 0"
            id="selectEmpresa"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-select
              v-model="segmentoSelect3"
              :items="segmentoLocal"
              item-value="idExibicao"
              item-text="segmento"
              label="Segmento Cliente"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <v-chip v-if="index === 1">
                  <span>{{ item.segmento }}, </span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text text-caption"
                >
                  (+{{ segmentoSelect3.length - 2 }} outros)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col
            id="btnRefazerCidade"
            cols="12"
            sm="2"
            md="2"
            lg="2"
          >
            <v-btn
              class="pa-2 ma-2"
              small
              :color="corPrimaria"
              dark
              @click="updateCidade3()"
            >
              <v-icon>
                mdi-reload-alert
              </v-icon>
              Refazer
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="exibirFiltrosCidades">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Controle de Mix Médio praticado por cidade
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('238')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-grafico-mix-medio-cidade3 />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import MaisVida from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import html2canvas from 'html2canvas'

  export default {
    name: 'PageMaisVida12',
    emits: ['updateFormMaisVida', 'updateFormMaisVidaCidade1', 'updateFormMaisVidaCidade2', 'updateFormMaisVidaCidade3', 'enableConsultas', 'disableTooltipMixGeral', 'disableTooltipMixCidade1', 'disableTooltipMixCidade2', 'disableTooltipMixCidade3', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardMixMedioGeral: () => import('../../graficos/Comercial/MixMedioGeral'),
      DashboardGraficoMixMedioCidade1: () => import('../../graficos/Comercial/MixMedioCidade1'),
      DashboardGraficoMixMedioCidade2: () => import('../../graficos/Comercial/MixMedioCidade2'),
      DashboardGraficoMixMedioCidade3: () => import('../../graficos/Comercial/MixMedioCidade3'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      link: window.location.href,
      clientes: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      segmento: [],
      cidadeLocal: [],
      areaLocal: [],
      redeLocal: [],
      vendedorLocal: [],
      segmentoLocal: [],
      segmentoSelect1: [],
      segmentoSelect2: [],
      segmentoSelect3: [],
      cidadeSelect1: [],
      cidadeSelect2: [],
      cidadeSelect3: [],
      areaSelect1: [],
      areaSelect2: [],
      areaSelect3: [],
      redeSelect1: [],
      redeSelect2: [],
      redeSelect3: [],
      vendedorSelect1: [],
      vendedorSelect2: [],
      vendedorSelect3: [],
      filterAreas1: [],
      filterAreas2: [],
      filterAreas3: [],
      filterRedes1: [],
      filterRedes2: [],
      filterRedes3: [],
      filterVendedor1: [],
      filterVendedor2: [],
      filterVendedor3: [],
      filtroAreas: '',
      filtroAreas2: '',
      filtroAreas3: '',
      filtroRedes: '',
      filtroRedes2: '',
      filtroRedes3: '',
      filtroVendedores: '',
      filtroVendedores2: '',
      filtroVendedores3: '',
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: false,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: false,
      enableLinhas: false,
      clienteTotal: 0,
      enableBtn: true,
      disableBtn: false,
      enableDatas: true,
      enableSegmento: true,
      enableProdutoMultiplo: false,
      exibirFiltrosCidades: false,
      codigo: 0,
      orientacao: [],
      textoMixMedio: '',
      textoMixMedioCidade: '',
      codigoIds: ['237', '238'],
      dynamicPaddingMixMedio: '',
      imprimindo: false,
      enableBtnPrint: false,
      dataGeral: '',
      dadosGeral: [],
      dataCidade1: '',
      dadosCidade1: [],
      dataCidade2: '',
      dadosCidade2: [],
      dataCidade3: '',
      dadosCidade3: [],
      valorMixGeral: 0,
      valorMixCidade1: 0,
      valorMixCidade2: 0,
      valorMixCidade3: 0,
      headers: [
        { text: 'Cod. cliente', value: 'codCliente', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Rede', value: 'nomeRede', align: 'left', class: 'black--text title' },
        { text: 'Mix', value: 'mix', align: 'left', class: 'black--text title' },
      ],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      likesAllRedes () {
        return this.redeSelect1.length === this.redeLocal.length
      },

      likesSomeRedes () {
        return this.redeSelect1.length > 0 && !this.likesAllRedes
      },

      iconRedes () {
        if (this.likesAllRedes) return 'mdi-close-box'
        if (this.likesSomeRedes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllRedes2 () {
        return this.redeSelect2.length === this.redeLocal.length
      },

      likesSomeRedes2 () {
        return this.redeSelect2.length > 0 && !this.likesAllRedes
      },

      iconRedes2 () {
        if (this.likesAllRedes) return 'mdi-close-box'
        if (this.likesSomeRedes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllRedes3 () {
        return this.redeSelect3.length === this.redeLocal.length
      },

      likesSomeRedes3 () {
        return this.redeSelect3.length > 0 && !this.likesAllRedes
      },

      iconRedes3 () {
        if (this.likesAllRedes) return 'mdi-close-box'
        if (this.likesSomeRedes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas () {
        return this.areaSelect1.length === this.areaLocal.length
      },

      likesSomeAreas () {
        return this.areaSelect1.length > 0 && !this.likesAllAreas
      },

      iconAreas () {
        if (this.likesAllAreas) return 'mdi-close-box'
        if (this.likesSomeAreas) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas2 () {
        return this.areaSelect2.length === this.areaLocal.length
      },

      likesSomeAreas2 () {
        return this.areaSelect2.length > 0 && !this.likesAllAreas2
      },

      iconAreas2 () {
        if (this.likesAllAreas2) return 'mdi-close-box'
        if (this.likesSomeAreas2) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas3 () {
        return this.areaSelect3.length === this.areaLocal.length
      },

      likesSomeAreas3 () {
        return this.areaSelect3.length > 0 && !this.likesAllAreas3
      },

      iconAreas3 () {
        if (this.likesAllAreas3) return 'mdi-close-box'
        if (this.likesSomeAreas3) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllVendedor1 () {
        return this.vendedorSelect1.length === this.vendedorLocal.length
      },

      likesSomeVendedor1 () {
        return this.vendedorSelect1.length > 0 && !this.likesAllAreas1
      },

      iconVendedores () {
        if (this.likesAllAreas1) return 'mdi-close-box'
        if (this.likesSomeAreas1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllVendedor2 () {
        return this.vendedorSelect2.length === this.vendedorLocal.length
      },

      likesSomeVendedor2 () {
        return this.vendedorSelect2.length > 0 && !this.likesAllAreas3
      },

      iconVendedores2 () {
        if (this.likesAllAreas2) return 'mdi-close-box'
        if (this.likesSomeAreas2) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllVendedor3 () {
        return this.vendedorSelect3.length === this.vendedorLocal.length
      },

      likesSomeVendedor3 () {
        return this.vendedorSelect3.length > 0 && !this.likesAllAreas3
      },

      iconVendedores3 () {
        if (this.likesAllAreas3) return 'mdi-close-box'
        if (this.likesSomeAreas3) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
    },

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-mix-medio-geral', this.handleDadosMixMedioGeral)

      eventEmit.$on('set-dados-mix-medio-cidade1', this.handleDadosMixMedioCidade1)

      eventEmit.$on('set-dados-mix-medio-cidade2', this.handleDadosMixMedioCidade2)

      eventEmit.$on('set-dados-mix-medio-cidade3', this.handleDadosMixMedioCidade3)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-mix-medio-geral', this.handleDadosMixMedioGeral)

      eventEmit.$off('set-dados-mix-medio-cidade1', this.handleDadosMixMedioCidade1)

      eventEmit.$off('set-dados-mix-medio-cidade2', this.handleDadosMixMedioCidade2)

      eventEmit.$off('set-dados-mix-medio-cidade3', this.handleDadosMixMedioCidade3)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Mix Médio')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        Permissao.showEmpresas(localStorage.tokencontrato, localStorage.username).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.segmentos) {
              this.segmentoLocal.push(resposta.data.segmentos[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        MaisVida.showFiltrosPagina(this.dataInicial, this.dataFinal, localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.cidades) {
              this.cidadeLocal.push(resposta.data.cidades[i])
            }

            for (i in resposta.data.areas) {
              this.areaLocal.push(resposta.data.areas[i])
            }

            for (i in resposta.data.redes) {
              this.redeLocal.push(resposta.data.redes[i])
            }

            for (i in resposta.data.vendedores) {
              this.vendedorLocal.push(resposta.data.vendedores[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingMixMedio = 'padding-right: 106rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingMixMedio = 'padding-right: 86rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingMixMedio = 'padding-right: 9rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingMixMedio = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingMixMedio = 'padding-right: 67rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevolucao, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, receita, segmento, segmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.segmento = segmento

        this.dataGeral = ''
        this.dadosGeral = []
        this.valorMixGeral = 0

        this.enableBtnPrint = false

        this.updateDados()
      },

      handleDadosMixMedioGeral (data, dadosTabela, valor) {
        this.dataGeral = data
        this.dadosGeral = dadosTabela
        this.valorMixGeral = valor

        this.enableBtnPrint = true

        eventEmit.$emit('disable-tooltip-mix-geral')
      },

      handleDadosMixMedioCidade1 (data, dadosTabela, valor) {
        this.dataCidade1 = data
        this.dadosCidade1 = dadosTabela
        this.valorMixCidade1 = valor

        this.enableBtnPrint = true

        eventEmit.$emit('disable-tooltip-mix-cidade1')
      },

      handleDadosMixMedioCidade2 (data, dadosTabela, valor) {
        this.dataCidade2 = data
        this.dadosCidade2 = dadosTabela
        this.valorMixCidade2 = valor

        this.enableBtnPrint = true

        eventEmit.$emit('disable-tooltip-mix-cidade2')
      },

      handleDadosMixMedioCidade3 (data, dadosTabela, valor) {
        this.dataCidade3 = data
        this.dadosCidade3 = dadosTabela
        this.valorMixCidade3 = valor

        this.enableBtnPrint = true

        eventEmit.$emit('disable-tooltip-mix-cidade3')
      },

      updateDados () {
        eventEmit.$emit('enable-consultas')

        this.cidadeSelect1 = []
        this.cidadeSelect2 = []
        this.cidadeSelect3 = []

        eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.segmento)

        this.exibirFiltrosCidades = true
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateCidade1 () {
        if (this.cidadeSelect1.cidade) {
          this.dataCidade1 = ''
          this.dadosCidade1 = []
          this.valorMixCidade1 = 0

          this.enableBtnPrint = false

          eventEmit.$emit('update-form-mais-vida-cidade1', this.dataInicial, this.dataFinal, this.select, this.cidadeSelect1, this.areaSelect1, this.vendedorSelect1, this.redeSelect1, this.produtos, this.linhas, this.clientes, this.segmentoSelect1)
        } else {
          alert('Favor selecionar uma cidade para exibir os dados.')
        }
      },

      updateCidade2 () {
        if (this.cidadeSelect2.cidade) {
          this.dataCidade2 = ''
          this.dadosCidade2 = []
          this.valorMixCidade2 = 0

          this.enableBtnPrint = false

          eventEmit.$emit('update-form-mais-vida-cidade2', this.dataInicial, this.dataFinal, this.select, this.cidadeSelect2, this.areaSelect2, this.vendedorSelect2, this.redeSelect2, this.produtos, this.linhas, this.clientes, this.segmentoSelect2)
        } else {
          alert('Favor selecionar uma cidade para exibir os dados.')
        }
      },

      updateCidade3 () {
        if (this.cidadeSelect3.cidade) {
          this.dataCidade3 = ''
          this.dadosCidade3 = []
          this.valorMixCidade3 = 0

          this.enableBtnPrint = false

          eventEmit.$emit('update-form-mais-vida-cidade3', this.dataInicial, this.dataFinal, this.select, this.cidadeSelect3, this.areaSelect3, this.vendedorSelect3, this.redeSelect3, this.produtos, this.linhas, this.clientes, this.segmentoSelect3)
        } else {
          alert('Favor selecionar uma cidade para exibir os dados.')
        }
      },

      filterAreasToggle () {
        if (this.filtroAreas.length > 0) {
          for (let i = 0; i < this.areaLocal.length; i++) {
            if (this.areaLocal[i].area.toLowerCase().includes(this.filtroAreas.toLowerCase())) {
              this.filterAreas1.push(this.areaLocal[i])
            }
          }
        } else {
          this.filterAreas1 = []
        }
      },

      toggleAreas () {
        this.$nextTick(() => {
          if (this.likesAllAreas) {
            this.areaSelect1 = []
          } else {
            if (this.filterAreas1.length > 0) {
              this.areaSelect1 = this.filterAreas1
            } else {
              this.areaSelect1 = this.areaLocal.slice()
            }
          }
        })
      },

      filterRedesToggle () {
        if (this.filtroRedes.length > 0) {
          for (let i = 0; i < this.redeLocal.length; i++) {
            if (this.redeLocal[i].rede.toLowerCase().includes(this.filtroRedes.toLowerCase())) {
              this.filterRedes1.push(this.redeLocal[i])
            }
          }
        } else {
          this.filterRedes1 = []
        }
      },

      toggleRedes () {
        this.$nextTick(() => {
          if (this.likesAllRedes) {
            this.redeSelect1 = []
          } else {
            if (this.filterRedes1.length > 0) {
              this.redeSelect1 = this.filterRedes1
            } else {
              this.redeSelect1 = this.redeLocal.slice()
            }
          }
        })
      },

      filterVendedoresToggle () {
        if (this.filtroVendedores.length > 0) {
          for (let i = 0; i < this.vendedorLocal.length; i++) {
            if (this.vendedorLocal[i].vendedor.toLowerCase().includes(this.filtroVendedores.toLowerCase())) {
              this.filterVendedor1.push(this.vendedorLocal[i])
            }
          }
        } else {
          this.filterVendedor1 = []
        }
      },

      toggleVendedores () {
        this.$nextTick(() => {
          if (this.likesAllVendedor1) {
            this.vendedorSelect1 = []
          } else {
            if (this.filterVendedor1.length > 0) {
              this.vendedorSelect1 = this.filterVendedor1
            } else {
              this.vendedorSelect1 = this.vendedorLocal.slice()
            }
          }
        })
      },

      filterAreasToggle2 () {
        if (this.filtroAreas2.length > 0) {
          for (let i = 0; i < this.areaLocal.length; i++) {
            if (this.areaLocal[i].area.toLowerCase().includes(this.filtroAreas2.toLowerCase())) {
              this.filterAreas2.push(this.areaLocal[i])
            }
          }
        } else {
          this.filterAreas2 = []
        }
      },

      toggleAreas2 () {
        this.$nextTick(() => {
          if (this.likesAllAreas2) {
            this.areaSelect2 = []
          } else {
            if (this.filterAreas2.length > 0) {
              this.areaSelect2 = this.filterAreas2
            } else {
              this.areaSelect2 = this.areaLocal.slice()
            }
          }
        })
      },

      filterRedesToggle2 () {
        if (this.filtroRedes2.length > 0) {
          for (let i = 0; i < this.redeLocal.length; i++) {
            if (this.redeLocal[i].rede.toLowerCase().includes(this.filtroRedes2.toLowerCase())) {
              this.filterRedes2.push(this.redeLocal[i])
            }
          }
        } else {
          this.filterRedes2 = []
        }
      },

      toggleRedes2 () {
        this.$nextTick(() => {
          if (this.likesAllRedes2) {
            this.redeSelect2 = []
          } else {
            if (this.filterRedes2.length > 0) {
              this.redeSelect2 = this.filterRedes2
            } else {
              this.redeSelect2 = this.redeLocal.slice()
            }
          }
        })
      },

      filterVendedoresToggle2 () {
        if (this.filtroVendedores2.length > 0) {
          for (let i = 0; i < this.vendedorLocal.length; i++) {
            if (this.vendedorLocal[i].vendedor.toLowerCase().includes(this.filtroVendedores2.toLowerCase())) {
              this.filterVendedor2.push(this.vendedorLocal[i])
            }
          }
        } else {
          this.filterVendedor2 = []
        }
      },

      toggleVendedores2 () {
        this.$nextTick(() => {
          if (this.likesAllVendedor2) {
            this.vendedorSelect1 = []
          } else {
            if (this.filterVendedor2.length > 0) {
              this.vendedorSelect2 = this.filterVendedor2
            } else {
              this.vendedorSelect2 = this.vendedorLocal.slice()
            }
          }
        })
      },

      filterAreasToggle3 () {
        if (this.filtroAreas3.length > 0) {
          for (let i = 0; i < this.areaLocal.length; i++) {
            if (this.areaLocal[i].area.toLowerCase().includes(this.filtroAreas3.toLowerCase())) {
              this.filterAreas3.push(this.areaLocal[i])
            }
          }
        } else {
          this.filterAreas3 = []
        }
      },

      toggleAreas3 () {
        this.$nextTick(() => {
          if (this.likesAllAreas3) {
            this.areaSelect3 = []
          } else {
            if (this.filterAreas3.length > 0) {
              this.areaSelect3 = this.filterAreas3
            } else {
              this.areaSelect3 = this.areaLocal.slice()
            }
          }
        })
      },

      filterRedesToggle3 () {
        if (this.filtroRedes3.length > 0) {
          for (let i = 0; i < this.redeLocal.length; i++) {
            if (this.redeLocal[i].rede.toLowerCase().includes(this.filtroRedes3.toLowerCase())) {
              this.filterRedes3.push(this.redeLocal[i])
            }
          }
        } else {
          this.filterRedes3 = []
        }
      },

      toggleRedes3 () {
        this.$nextTick(() => {
          if (this.likesAllRedes3) {
            this.redeSelect3 = []
          } else {
            if (this.filterRedes3.length > 0) {
              this.redeSelect3 = this.filterRedes3
            } else {
              this.redeSelect3 = this.redeLocal.slice()
            }
          }
        })
      },

      filterVendedoresToggle3 () {
        if (this.filtroVendedores3.length > 0) {
          for (let i = 0; i < this.vendedorLocal.length; i++) {
            if (this.vendedorLocal[i].vendedor.toLowerCase().includes(this.filtroVendedores3.toLowerCase())) {
              this.filterVendedor3.push(this.vendedorLocal[i])
            }
          }
        } else {
          this.filterVendedor3 = []
        }
      },

      toggleVendedores3 () {
        this.$nextTick(() => {
          if (this.likesAllVendedor3) {
            this.vendedorSelect3 = []
          } else {
            if (this.filterVendedor3.length > 0) {
              this.vendedorSelect3 = this.filterVendedor3
            } else {
              this.vendedorSelect3 = this.vendedorLocal.slice()
            }
          }
        })
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados mix médio geral'
          pdf.text(filtro, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 125) {
            pdf.addPage()

            posYFiltros = 10
          }

          pdf.text('Controle de Mix Médio praticado geral - Semana Selecionada: ' + this.dataGeral + ' - Mix Médio: ' + this.valorMixGeral, 15, posYFiltros)
          posYFiltros += 10

          const graficoMixGeral = document.getElementById('myChartMaisVida9')
          const canvasGraficoMixGeral = await html2canvas(graficoMixGeral)
          const imgWidthGraficoMixGeral = 150
          const imgHeightGraficoMixGeral = (canvasGraficoMixGeral.height * imgWidthGraficoMixGeral) / canvasGraficoMixGeral.width

          pdf.addImage(canvasGraficoMixGeral.toDataURL('image/png'), 'PNG', 70, posYFiltros, imgWidthGraficoMixGeral, imgHeightGraficoMixGeral)

          posYFiltros += imgHeightGraficoMixGeral + 10

          if (posYFiltros > 180) {
            pdf.addPage()

            posYFiltros = 10
          }

          const tableDadosGeral = this.dadosGeral.map(item => [item.codCliente, item.cliente, item.nomeRede, item.mix])
          pdf.autoTable({
            head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: tableDadosGeral.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          if (this.dadosCidade1.length > 0) {
            pdf.addPage()
            pdf.setFontSize(16)

            posYFiltros = 10

            pdf.text('Filtros selecionados mix médio cidade 1', 105, posYFiltros)
            posYFiltros += 10
            pdf.setFontSize(10)
            pdf.text(datas, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))

            pdf.text('Cidade Selecionada: ' + this.cidadeSelect1.cidade, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect1.map(a => a.area))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect1.map(v => v.vendedor))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect1.map(r => r.rede))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmentoSelect1.map(se => se.segmento))

            pdf.text('Controle de Mix Médio praticado por cidade - Semana Selecionada: ' + this.dataCidade1 + ' - Mix Médio: ' + this.valorMixCidade1, 15, posYFiltros)
            posYFiltros += 10

            if (posYFiltros > 125) {
              pdf.addPage()

              posYFiltros = 10
            }

            const graficoMixCidade1 = document.getElementById('myChartMaisVida10')
            const canvasGraficoMixCidade1 = await html2canvas(graficoMixCidade1)
            const imgWidthGraficoMixCidade1 = 150
            const imgHeightGraficoMixCidade1 = (canvasGraficoMixCidade1.height * imgWidthGraficoMixCidade1) / canvasGraficoMixCidade1.width

            pdf.addImage(canvasGraficoMixCidade1.toDataURL('image/png'), 'PNG', 70, posYFiltros, imgWidthGraficoMixCidade1, imgHeightGraficoMixCidade1)

            posYFiltros += imgHeightGraficoMixCidade1 + 10

            if (posYFiltros > 180) {
              pdf.addPage()

              posYFiltros = 10
            }

            const tableDadosCidade1 = this.dadosCidade1.map(item => [item.codCliente, item.cliente, item.nomeRede, item.mix])
            pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: tableDadosCidade1.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posYFiltros,
              styles: { fontSize: 10 },
            })
          }

          if (this.dadosCidade2.length > 0) {
            pdf.addPage()
            pdf.setFontSize(16)

            posYFiltros = 10

            pdf.text('Filtros selecionados mix médio cidade 2', 105, posYFiltros)
            posYFiltros += 10
            pdf.setFontSize(10)
            pdf.text(datas, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))

            pdf.text('Cidade Selecionada: ' + this.cidadeSelect2.cidade, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect2.map(a => a.area))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect2.map(v => v.vendedor))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect2.map(r => r.rede))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmentoSelect2.map(se => se.segmento))

            pdf.text('Controle de Mix Médio praticado por cidade - Semana Selecionada: ' + this.dataCidade2 + ' - Mix médio: ' + this.valorMixCidade2, 15, posYFiltros)
            posYFiltros += 10

            if (posYFiltros > 125) {
              pdf.addPage()

              posYFiltros = 10
            }

            const graficoMixCidade2 = document.getElementById('myChartMaisVida11')
            const canvasGraficoMixCidade2 = await html2canvas(graficoMixCidade2)
            const imgWidthGraficoMixCidade2 = 150
            const imgHeightGraficoMixCidade2 = (canvasGraficoMixCidade2.height * imgWidthGraficoMixCidade2) / canvasGraficoMixCidade2.width

            pdf.addImage(canvasGraficoMixCidade2.toDataURL('image/png'), 'PNG', 70, posYFiltros, imgWidthGraficoMixCidade2, imgHeightGraficoMixCidade2)

            posYFiltros += imgHeightGraficoMixCidade2 + 10

            if (posYFiltros > 180) {
              pdf.addPage()

              posYFiltros = 10
            }

            const tableDadosCidade2 = this.dadosCidade2.map(item => [item.codCliente, item.cliente, item.nomeRede, item.mix])
            pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: tableDadosCidade2.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posYFiltros,
              styles: { fontSize: 10 },
            })
          }

          if (this.dadosCidade3.length > 0) {
            pdf.addPage()
            pdf.setFontSize(16)

            posYFiltros = 10

            pdf.text('Filtros selecionados mix médio cidade 3', 105, posYFiltros)
            posYFiltros += 10
            pdf.setFontSize(10)
            pdf.text(datas, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))

            pdf.text('Cidade Selecionada: ' + this.cidadeSelect3.cidade, 15, posYFiltros)

            posYFiltros += 10

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect3.map(a => a.area))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect3.map(v => v.vendedor))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect3.map(r => r.rede))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmentoSelect3.map(se => se.segmento))

            pdf.text('Controle de Mix Médio praticado por cidade - Semana Selecionada: ' + this.dataCidade3 + ' - Mix Médio: ' + this.valorMixCidade3, 15, posYFiltros)
            posYFiltros += 10

            if (posYFiltros > 125) {
              pdf.addPage()

              posYFiltros = 10
            }

            const graficoMixCidade3 = document.getElementById('myChartMaisVida12')
            const canvasGraficoMixCidade3 = await html2canvas(graficoMixCidade3)
            const imgWidthGraficoMixCidade3 = 150
            const imgHeightGraficoMixCidade3 = (canvasGraficoMixCidade3.height * imgWidthGraficoMixCidade3) / canvasGraficoMixCidade3.width

            pdf.addImage(canvasGraficoMixCidade3.toDataURL('image/png'), 'PNG', 70, posYFiltros, imgWidthGraficoMixCidade3, imgHeightGraficoMixCidade3)

            posYFiltros += imgHeightGraficoMixCidade3 + 10

            if (posYFiltros > 180) {
              pdf.addPage()

              posYFiltros = 10
            }

            const tableDadosCidade3 = this.dadosCidade3.map(item => [item.codCliente, item.cliente, item.nomeRede, item.mix])
            pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: tableDadosCidade3.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posYFiltros,
              styles: { fontSize: 10 },
            })
          }

          pdf.save('relatorio_mix_medio.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.produto = ''
          this.tableVendas = []
          this.tableSemMovimento = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  #btnRefazerCidade
    margin: 1rem 0 0 0

  #cidadeSelectBtn
    margin: 0 0 0 1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemMixMedio
    margin: -2rem 0 0 -1rem
</style>
